@let blok = block();

<ng-template #headingContent>
    {{ blok?.textContentBeginning }}
    <span [ngClass]="getInnerClasses()">{{ blok?.textContent }}</span>
    {{ blok?.textContentEnding }}
</ng-template>

@switch (blok?.level) {
    @case (2) {
        <h2 [ngClass]="getAllClasses()">
            <ng-container *ngTemplateOutlet="headingContent" />
        </h2>
    }
    @case (3) {
        <h3 [ngClass]="getAllClasses()">
            <ng-container *ngTemplateOutlet="headingContent" />
        </h3>
    }
    @case (4) {
        <h4 [ngClass]="getAllClasses()">
            <ng-container *ngTemplateOutlet="headingContent" />
        </h4>
    }
    @case (5) {
        <h5 [ngClass]="getAllClasses()">
            <ng-container *ngTemplateOutlet="headingContent" />
        </h5>
    }
    @case (6) {
        <h6 [ngClass]="getAllClasses()">
            <ng-container *ngTemplateOutlet="headingContent" />
        </h6>
    }
    @default {
        <h1 [ngClass]="getAllClasses()">
            <ng-container *ngTemplateOutlet="headingContent" />
        </h1>
    }
}
